import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const QuestionActionSummaryComponent = ({ questionActions }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={5}>
        {t('Questionnaire.QuestionAction.QuestionActionType')} :{' '}
        <span> {questionActions.questionActionTypes ? questionActions.questionActionTypes.name : ''} </span>        
      </Grid>
    </Grid>
  );
};

QuestionActionSummaryComponent.propTypes = {
  questionActions: PropTypes.object.isRequired
};

export default QuestionActionSummaryComponent;
